// components
import { Translation } from 'components/Translation/Translation';

// utils
import { decodingContent } from 'utils/decodingContent';

interface ContactDetailProps {
  phone: string;
  fax: string;
}

export function ContactDetail({ phone, fax }: Readonly<ContactDetailProps>) {
  return (
    <>
      {phone && (
        <li>
          <Translation id="web20_locator_phone" />: {decodingContent(phone)}
        </li>
      )}
      {fax && (
        <li>
          <Translation id="web20_locator_fax" />: {decodingContent(fax)}
        </li>
      )}
    </>
  );
}
